import jquery from "jquery";
window.jQuery = jquery;
window.$ = jquery;
import "bootstrap-sass";
import "progressbar.js";
import "jquery-smooth-scroll";
import "jquery-mask-plugin";
import "jquery-validation";
import "./common.js";
import "./phone_number.js";
import "./account.js";
